<!-- <ng-container *ngIf="screenWidth > 768"> -->
  <app-quote-step10-desktop [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step10-desktop>
<!-- </ng-container> -->

<!-- <ng-container *ngIf="screenWidth <= 768">
  <app-quote-step10-mobile [screenWidth] = "screenWidth" [currentStep] = "currentStep" (onNextStep)= "nextStep()" (onPrevStep)= "prevStep()"></app-quote-step10-mobile>
</ng-container> -->